export default {
  workflowTour: [
    {
      id: 'workflow-tags-step',
      arrow: true,
      classes: 'workflow-tour workflow-tour--steps temp-hide select-tags',
      title: 'Specify your search term attributes to easily find what you’re seeking.',
      text: 'Refine your search to get the most precise results.',
      buttons: ['next', 'cancel'],
      attachToElement: '#workflow-tags',
      attachOn: 'bottom-start',
      modalOverlayOpeningRadius: 5,
      modalOverlayOpeningPadding:5,
      canClickTarget: false
    },
    {
      id: 'workflow-step-1',
      arrow: true,
      classes: 'workflow-tour workflow-tour--steps temp-hide select-product',
      title: 'Select a product for your experiment step',
      text: 'Click here to select products you want to use for a particular step. If the product you need is missing you add your own one.',
      buttons: ['next', 'back', 'cancel'],
      attachToElement: '#tour-step1 button',
      attachOn: 'bottom-end',
      modalOverlayOpeningRadius: 10,
      canClickTarget: false
    },
    {
      id: 'workflow-step-2',
      arrow: true,
      classes: 'workflow-tour workflow-tour--steps  add-product',
      title: 'Add more products to one step',
      text: 'Click here to select more products you want to use for a particular step.',
      buttons: ['next', 'back', 'cancel'],
      attachToElement: '#add-product',
      attachOn: 'bottom-end',
      modalOverlayOpeningRadius: 5,
      modalOverlayOpeningPadding: 5,
      canClickTarget: false
    },
    {
      id: 'workflow-step-3',
      arrow: true,
      classes: 'workflow-tour workflow-tour--steps save-workflow',
      title: 'Save and store your experiments',
      text: 'Easily and safely store all your experiments. Access them anytime from anywhere',
      buttons: ['next', 'back', 'cancel'],
      attachToElement: '#tour-step3',
      attachOn: 'top-start',
      modalOverlayOpeningRadius: 5,
      modalOverlayOpeningPadding: 0,
      canClickTarget: false
    },
    {
      id: 'workflow-step-4',
      arrow: true,
      classes: 'workflow-tour workflow-tour--steps temp-hide share-workflow',
      title: 'Download and Share your experiment',
      mobileTitle: 'Share your experiment',
      text: 'Collaborate with your coleagues and supercharge your teamwork.',
      buttons: ['next', 'back', 'cancel'],
      mobileButtons: ['finish', 'back'],
      attachToElement: '#tour-step4',
      attachOn: 'right-start',
      mobileAttachOn: 'bottom-end',
      modalOverlayOpeningRadius: 5,
      modalOverlayOpeningPadding: 5,
      canClickTarget: false
    },
    {
      id: 'workflow-step-5',
      arrow: true,
      classes: 'workflow-tour workflow-tour--steps temp-hide',
      title: 'Add personal notes and access protocols',
      text: 'Get a secure, modern and compliant system to track your experiments efficiently but also manage your lab with a powerful and flexible database.',
      buttons: ['finish', 'back'],
      attachToElement: '#tour-step5',
      attachOn: 'bottom-end',
      modalOverlayOpeningRadius: 5,
      modalOverlayOpeningPadding: 5,
      canClickTarget: false
    },

  ],
  productTour: [
    {
      id:'product-tour-step-1',
      arrow: true,
      classes: 'product-tour product-tour--steps',
      title: 'Select an alternative product',
      text: 'Click here to select products you want to use for a particular step. If the product you need is missing you add your own one.',
      buttons: ['next', 'cancel'],
      attachToElement: '.product-tour-step-1',
      attachOn: 'right-start',
      modalOverlayOpeningRadius: 10,
    },

    {
      id:'product-tour-step-2',
      arrow: true,
      classes: 'workflow-tour workflow-tour--steps',
      title: 'Go to attributes selection',
      text: 'When you have chosen a maching product go to the next step.',
      buttons: ['modalSelectProductGroup', 'back', 'cancel'],
      attachToElement: '.product-tour-step-2',
      attachOn: 'bottom-end',
      modalOverlayOpeningRadius: 10,

    },
    {
      id:'product-tour-step-3',
      arrow: true,
      classes: 'product-tour product-tour--steps',
      title: 'Select product attributes matching your criteria',
      text: 'When finding best product you can choose from various variants.',
      buttons: ['next', 'back', 'cancel'],
      attachToElement: '.product-tour-step-3',
      attachOn: 'bottom-end',
      modalOverlayOpeningRadius: 10,
      modalOverlayOpeningPadding: 8,
    },
    {
      id:'product-tour-step-4',
      arrow: true,
      classes: 'product-tour product-tour--steps',
      title: 'Apply selected product to designed experiment',
      text: 'When you have chosen a maching product apply it to your experiment.',
      buttons: ['finish', 'back' ],
      attachToElement: '.product-tour-step-4',
      attachOn: 'bottom-end',
      modalOverlayOpeningRadius: 10,
    },
  ],
  finderTour: [
    {
      id:'finder-step1',
      arrow: true,
      classes: 'finder-tour finder-tour--steps starting-material',
      text: 'First, pick your starting material. Or start with another dropdown selection.',
      buttons: null,
      attachToElement: '#tour-finder .home .categories #finder-tour-step1',
      attachOn: 'top-start',
      modalOverlayOpeningRadius: 10,
    },
    {
      id:'finder-step2',
      arrow: true,
      classes: 'finder-tour finder-tour--steps analyte',
      text: 'Now, pick your analyte',
      buttons: null,
      attachToElement: '#tour-finder .home .categories #finder-tour-step2',
      attachOn: 'top-end',
      modalOverlayOpeningRadius: 10,
    },
    {
      id:'finder-step3',
      arrow: true,
      classes: 'finder-tour finder-tour--steps',
      text: 'What type of analysis you want to apply?',
      buttons: null,
      attachToElement: '#tour-finder .home .categories #finder-tour-step3',
      attachOn: 'top-end',
      modalOverlayOpeningRadius: 10,
    },
    {
      id:'finder-step4',
      arrow: true,
      classes: 'finder-tour finder-tour--steps application',
      text: 'Select your application area',
      buttons: null,
      attachToElement: '#tour-finder .home .categories #finder-tour-step4',
      attachOn: 'top-end',
      modalOverlayOpeningRadius: 10,
    },
    {
      id:'finder-step5',
      arrow: true,
      classes: 'finder-tour finder-tour--steps',
      text: "Based on selection, we'll show you the products and instruments you need to perform your experiment, including the relevant protocols.",
      buttons: null,
      attachToElement: '#tour-finder .home .workflow-ctas #show-workflow-btn',
      attachOn: 'bottom-start',
      modalOverlayOpeningRadius: 10,
    },

  ],
  elnTour: [
    {
      arrow: true,
      classes: 'eln-tour eln-tour--steps',
      title: 'Add your lab notes',
      text: 'Document your research execution by adding your lab notes.',
      buttons: ['next', 'cancel'],
      attachToElement: '#eln-tour-step1',
      attachOn: 'top-start',
      modalOverlayOpeningRadius: 10,
    },
    {
      arrow: true,
      classes: 'eln-tour eln-tour--steps',
      title: 'Find and download quick-start protocols',
      text: 'Find the required protocols to start your experiments.',
      buttons: ['finish', 'back'],
      attachToElement: '#eln-tour-step2',
      attachOn: 'top-start',
      modalOverlayOpeningRadius: 10,
    },
  ]
}
